"use client";
import { useRouter } from "next/navigation";
import { useState } from "react";

// Component for creating a trip
function ItineraryCreationForm() {
  const [city, setCity] = useState("");
  const [isInputFocused, setIsInputFocused] = useState(false);
  const router = useRouter();

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (city.trim()) {
      // Use standardized URL for base/unmodified itineraries
      const formattedCity = city.toLowerCase().trim();
      router.push(`/show/${formattedCity}`);
    }
  };

  return (
    <div className="w-full max-w-xl mx-auto">
      <form
        name="HomePageForm"
        className="flex flex-col gap-4 w-full"
        onSubmit={handleSubmit}
      >
        <div
          className={`relative w-full bg-white/10 border-2 ${
            isInputFocused
              ? "border-white/50 bg-white/20 shadow-lg"
              : "border-white/20"
          } rounded-xl transition-all duration-300 backdrop-blur-md`}
        >
          <svg
            className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-white"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          </svg>
          <input
            autoFocus
            placeholder="Where do you want to go?"
            name="city"
            className="w-full bg-transparent border-none py-4 px-12 text-lg text-white placeholder-white/70 outline-none font-sans"
            value={city}
            onChange={(evt) => {
              const valueToSet = evt.target.value.replace(/[^a-z ]/gi, "");
              setCity(valueToSet);
            }}
            onFocus={() => setIsInputFocused(true)}
            onBlur={() => setIsInputFocused(false)}
          />
        </div>
        <button
          className={`flex items-center justify-center gap-2 cursor-pointer disabled:cursor-not-allowed ${
            city.trim()
              ? "bg-gradient-to-r from-orange-500 to-amber-400 hover:from-orange-600 hover:to-amber-500 transform hover:-translate-y-1"
              : "bg-gray-400 cursor-not-allowed"
          } text-white border-none rounded-xl py-4 px-6 text-lg font-semibold transition-all duration-300 shadow-md hover:shadow-lg`}
          type="submit"
          disabled={!city.trim()}
        >
          Plan My Trip
          <svg
            className="w-5 h-5"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="12 5 19 12 12 19"></polyline>
          </svg>
        </button>
      </form>
    </div>
  );
}

export default ItineraryCreationForm;
